import React from "react";
import { WizardMedication } from "@/types/medication";
import { Switch } from "@/components/ui/switch";
import { TimeSelectionButtons } from "./TimeSelectionButtons";
import { DosagePatternSelect } from "./DosagePatternSelect";

interface PatternStepProps {
  medication: WizardMedication;
  onChange: (medication: WizardMedication) => void;
}

export const PatternStep = ({ medication, onChange }: PatternStepProps) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <span className="text-base font-medium">Dosage Pattern</span>
        <div className="flex items-center gap-2">
          <span className="text-sm">Scheduled</span>
          <Switch
            checked={medication.isPRN}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onCheckedChange={(checked) =>
              onChange({ ...medication, isPRN: checked })
            }
          />
          <span className="text-sm">As needed (PRN)</span>
        </div>
      </div>

      {!medication.isPRN && (
        <DosagePatternSelect medication={medication} onChange={onChange} />
      )}

      <TimeSelectionButtons medication={medication} onChange={onChange} />
    </div>
  );
};
